import React from 'react';

interface ErrorStateProps {
  title: string;
  message: string;
  onRetry?: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ title, message, onRetry }) => {
  return (
    <div className='flex-1 flex items-center justify-center'>
      <div className='text-center text-red-600'>
        <div className='text-sm font-medium mb-1'>{title}</div>
        <div className='text-xs'>{message}</div>
        {onRetry && (
          <button
            onClick={onRetry}
            className='mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 text-sm'
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorState;